import React, {Component} from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import Moment from 'react-moment'
import moment from 'moment'

import styles from './BookingWidget.css';
import {faMapMarkerAlt, faCalendarAlt} from "@fortawesome/pro-light-svg-icons/index";
import Button from "../Button/Button";

export default class BookingWidget extends Component {
    render() {

        const {bookingAction, appointment} = this.props;

        return (
            <div className={styles.widget}>
                <div className={styles.content}>
                    <h3>Termindetails</h3>

                    <div className={styles.info}>
                    <span className={styles.label}>
                        <FontAwesomeIcon icon={faCalendarAlt} size="lg"/>
                        Wann?
                    </span>
                        <div>
                            {moment(appointment.date).format('DD.MM.YYYY')}
                            <br/>
                            {moment(appointment.date).format('HH:mm')} Uhr
                        </div>
                    </div>

                    <div className={[styles.info, styles.last].join(' ')}>
                    <span className={styles.label}>
                        <FontAwesomeIcon icon={faMapMarkerAlt} size="lg"/>
                        Wo?
                    </span>
                        {appointment.street} {appointment.housenumber}<br/>{appointment.plz} {appointment.city}
                    </div>
                </div>

                <Button href="#" onClick={bookingAction}>Termin jetzt buchen</Button>

            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/BookingWidget/BookingWidget.js